import { useMemo } from "react";
import axios from "axios";
import { useAuthInfo } from "@propelauth/react";
import { useAppSelector } from "../app/store/hooks";
import { selectUser } from "../app/auth/user/store/userSlice";
import { selectCurrentLanguageId } from "../app/store/i18nSlice";

// Dynamic baseUrl selection based on current hostname
const baseUrl =
    window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
        ? "http://localhost:5000/"
        : window.location.hostname === "fix-and-clean.biodit.com"
            ? "https://fix-and-clean-api.biodit.com/"
            : "https://fix-and-clean-api.biodit.info/";

//const testAuth = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjllYzhjOWE0LTFiNmMtNDkzNy04Y2JkLTc3MmM2ZWNjYmQ4OCJ9.eyJzdWIiOiJlMDQ3NTg0NS1hOGNkLTQ5YmUtYTE1Yy03OTU2YjFlZTMzYzEiLCJpYXQiOjE3MjE4MDUxMzMsImV4cCI6MTcyMjI2NTkzMywidXNlcl9pZCI6ImUwNDc1ODQ1LWE4Y2QtNDliZS1hMTVjLTc5NTZiMWVlMzNjMSIsImlzcyI6Imh0dHBzOi8vMjY4OTI0MTgxOS5wcm9wZWxhdXRodGVzdC5jb20iLCJlbWFpbCI6ImFzb2Zyb25pZXZAYmlvZGl0LmNvbSIsImZpcnN0X25hbWUiOiJBbGV4IiwibGFzdF9uYW1lIjoiU29mcm9uaWV2IiwidXNlcm5hbWUiOiJhc29mcm9uaWV2Iiwib3JnX2lkX3RvX29yZ19tZW1iZXJfaW5mbyI6eyJkZWU4ZjZlZC02MWFkLTQyOWYtYTA1Ni01Y2M0MjU3NmI5MzQiOnsib3JnX2lkIjoiZGVlOGY2ZWQtNjFhZC00MjlmLWEwNTYtNWNjNDI1NzZiOTM0Iiwib3JnX25hbWUiOiJCSU9ESVQiLCJ1cmxfc2FmZV9vcmdfbmFtZSI6ImJpb2RpdCIsIm9yZ19tZXRhZGF0YSI6e30sInVzZXJfcm9sZSI6IkdvZGZhdGhlciIsImluaGVyaXRlZF91c2VyX3JvbGVzX3BsdXNfY3VycmVudF9yb2xlIjpbIkdvZGZhdGhlciIsIk93bmVyIiwiQWRtaW4iLCJNZW1iZXIiLCJNYWluIENsZWFuZXIiLCJDbGVhbmVyIiwiUmVjZXB0aW9uIiwiVGVzdCJdLCJvcmdfcm9sZV9zdHJ1Y3R1cmUiOiJzaW5nbGVfcm9sZV9pbl9oaWVyYXJjaHkiLCJhZGRpdGlvbmFsX3JvbGVzIjpbXSwidXNlcl9wZXJtaXNzaW9ucyI6WyJwcm9wZWxhdXRoOjpjYW5faW52aXRlIiwicHJvcGVsYXV0aDo6Y2FuX2NoYW5nZV9yb2xlcyIsInByb3BlbGF1dGg6OmNhbl9yZW1vdmVfdXNlcnMiLCJwcm9wZWxhdXRoOjpjYW5fZWRpdF9vcmdfYWNjZXNzIiwicHJvcGVsYXV0aDo6Y2FuX3VwZGF0ZV9vcmdfbWV0YWRhdGEiLCJwcm9wZWxhdXRoOjpjYW5fdmlld19vdGhlcl9tZW1iZXJzIiwicm9vbXM6OnZpZXdfYXNzaWduZWQiLCJyb29tczo6c3RhcnRfY2xlYW5pbmciLCJyb29tczo6c3RvcF9jbGVhbmluZyIsInJlcG9ydHM6OnN1Ym1pdCIsInJlcG9ydHM6OnN1Ym1pdCIsImhvdGVsczo6Y29uZmlndXJlIiwicGF5bWVudHM6OnZpZXciLCJyb29tczo6YXNzaWduIiwicm9vbXM6bWFuYWdlIiwicm9vbXM6cmVxdWVzdF9leHByZXNzX2NsZWFuaW5nIiwicm9vbXM6dmlld19hbGwiLCJyb29tczp2aWV3X3N0YXR1cyIsInVzZXJzOjptYW5hZ2UiLCJob3RlbHM6Om1hbmFnZSIsInVzZXJzOmFjdGl2YXRlIiwidXNlcnM6ZGVhY3RpdmF0ZSIsInBheW1lbnRzOjptYW5hZ2UiLCJmbG9vcnM6bWFuYWdlIl19fSwicHJvcGVydGllcyI6eyJwaWN0dXJlX3VybCI6Imh0dHBzOi8vaW1nLnByb3BlbGF1dGguY29tLzJhMjdkMjM3LWRiOGMtNGY4Mi04NGZiLTU4MjRkZmFlZGM4Ny5wbmcifX0.XYT_u6wcYpFnX1q2y-r3_04sbiXemRQ7KEno2synnnAryAzncNlbQpnobiLfh1a5kPlqRGzwwrfx1guZhdJrtHktLRwTMAHMohh0zT4U0XdeRioPPC9YnkV91maFWs3LX_NzbA_iESo-YE6P-u8SdojgxmR87y9mEz1rTDcRSz1Cj7NVx6CTVzC-8d_fEhHJqW2ebak_iO_RHwPyddKLHYyuQ5woqOdDZv8IQLIxSEyFoP-N0x8pjbKNhHVBUVztABuznrBBXhN88hNjw1msJRoSAP_poMLjuZ1A_HzEqa2IqUSTfFMtebXOWkzSYGRrKFLgIwSTOt_OENxCi43ONQ'

export const useAxiosInstance = () => {
    const user = useAppSelector(selectUser);
    const authInfo = useAuthInfo();
    const currentLanguage = useAppSelector(selectCurrentLanguageId);

    // Get organization id from the user object
    const orgIds = Object.keys(user.org_id_to_org_member_info || {});
    const orgId = orgIds[0];

    const axiosInstance = useMemo(async () => {
        try {
            const orgAccessToken = await authInfo.tokens.getAccessTokenForOrg(orgId);
            const accessToken = orgAccessToken.accessToken;

            // Get user's preferred language - prioritize current app language over user's saved preference
            const userLanguage =
                currentLanguage || user.properties?.chosen_language || "en";

            // console.log("Access token:" ,accessToken);

            return axios.create({
                baseURL: baseUrl,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    organization_id: orgId,
                    "Accept-Language": userLanguage,
                },
            });
        } catch (error) {
            console.error("Error creating axios instance:", error);
            // Return a basic axios instance without auth if token fetch fails
            return axios.create({
                baseURL: baseUrl,
                headers: {
                    "Accept-Language": currentLanguage || "en",
                },
            });
        }
    }, [orgId, currentLanguage, user.properties?.chosen_language]);

    return axiosInstance;
};
